export default {
  SECTION_TITLE: 'sectionTitle',
  FORM_TITLE: 'formTitle',
  INFO_TITLE: 'infoTitle',
  INFO: 'info'
};
